module.exports = __webpack_public_path__ + "static/media/glasgow-bridge.003231ba.jpeg";